export default function MarketCardFaq () {
    return (
        <div>
            <h4>Q: Are you working on this page?</h4>
            <p>A: yes! I swear!</p>
        </div>
    )
 }